import { useMemo } from 'react';
// import {useLocation} from '@reach/router'
import { useRouter } from 'next/router';

export const MCP_CALLBACK_ERROR_CODE: Record<string, string> = {
  '10001': 'No permission.',
  '10002': 'Approve failed.',
  '10003': 'Invalid token.',
  '10004': 'Address not registered.',
  '10005': 'Already existed.',
  '10006': "Your signing address doesn't belong to the requesting profile, please use valid address to sign",

  '40001': 'Invalid parameters.',
  '40002': 'Invalid sign message.',
  '40003': 'Invalid signature.',
  '40004': 'Invalid method id.',
  '40005': 'Invalid variable name.',
  '40006': 'Too many requests and the max is 50.',
  '40007': 'Not found.',
  '40008': 'Something went wrong.',
  '40009': 'Invalid call.'
};

export const useMCPCallbackParams = () => {
  // const location = useLocation()
  const router = useRouter();
  const args = useMemo(() => {
    if (router.query) {
      // const params = new URLSearchParams(location.search)
      // const authId = params.get('authId')
      // const profileAddress = params.get('profileAddress')
      // const address = params.get('address')
      // const status = params.get('status')
      // const code = params.get('code')
      const authId = router.query.authId;
      const profileAddress = router.query.profileAddress;
      const address = router.query.address;
      const status = router.query.status;
      const code = router.query.code as string;
      if (status === 'success') {
        return {
          authId,
          profileAddress,
          address,
          succeed: true
        };
      } else {
        return {
          authId,
          profileAddress,
          code,
          succeed: false,
          message: MCP_CALLBACK_ERROR_CODE[code || '']
        };
      }
    }
    return null;
  }, [router]);
  return args;
};
